import httpClient, { ApiResponseType, FORM_DATA_CONFIG, queryBuilder } from 'packages/http_client';
import { UserType } from 'packages/user_repository';
import { unwrap } from './api';
import { ApiStatusType, ListApiResponseType, VentureBuilderApiType } from './types';
import { VENTURE_BUILDER_API } from './utils';

type ProfileApiType = VentureBuilderApiType & { photo?: string };
export type VentureBuilderProfileChanges = Pick<UserType, 'firstName' | 'lastName' | 'photo'>;

// Use the role's member record, as other portal profiles do. Editing the raw
// user would leave the VB record stale and its next save would overwrite it.
export const getVentureBuilderProfile = async (userId: number): Promise<UserType> => {
  if (!Number.isInteger(userId) || userId <= 0) throw new Error('Profile is unavailable');
  const response = await httpClient.get<ApiResponseType<ListApiResponseType<ProfileApiType>>>(
    VENTURE_BUILDER_API,
    { params: queryBuilder({ user_id: userId }).toObject() },
  );
  const { result } = unwrap(response);
  if (result?.length !== 1 || result[0].userID !== userId || result[0].id <= 0) {
    throw new Error('Profile is unavailable');
  }
  const profile = result[0];
  return {
    id: profile.id,
    username: profile.email,
    email: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    photo: profile.photo || '',
  };
};

export const updateVentureBuilderProfile = async (id: number, data: VentureBuilderProfileChanges) => {
  if (!Number.isInteger(id) || id <= 0) throw new Error('Profile is unavailable');
  const firstName = data.firstName.trim();
  const lastName = data.lastName.trim();
  if (!firstName || !lastName) throw new Error('First name and last name are required');
  const payload = new FormData();
  payload.append('_first_name', firstName);
  payload.append('_last_name', lastName);
  if (data.photo !== undefined) payload.append('_photo', data.photo);
  const response = await httpClient.put<ApiResponseType<ApiStatusType>>(
    `${VENTURE_BUILDER_API}/${id}`,
    payload,
    FORM_DATA_CONFIG,
  );
  unwrap(response);
};
